// extracted by mini-css-extract-plugin
export var bgtext = "home-module--bgtext--Leymk";
export var fadeInLeft = "home-module--fadeInLeft--5KT8R";
export var title = "home-module--title--iB3K9";